import { render, staticRenderFns } from "./EventCardResponsive.vue?vue&type=template&id=5de119a6&scoped=true"
import script from "./EventCardResponsive.vue?vue&type=script&lang=js"
export * from "./EventCardResponsive.vue?vue&type=script&lang=js"
import style0 from "./EventCardResponsive.vue?vue&type=style&index=0&id=5de119a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de119a6",
  null
  
)

export default component.exports